var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-full overflow-hidden flex-shrink-0 bg-hint",style:(_vm.style)},[(_vm.logoId)?_c('Attachment',{attrs:{"id":_vm.logoId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }